// extracted by mini-css-extract-plugin
export default {"modalAddress":"modalAddress_modalAddress__CAlra","body":"modalAddress_body__vQoog","title":"modalAddress_title__J7h2x"};